// extracted by mini-css-extract-plugin
export var mainFrame = "styles-module--mainFrame--r7OZC";